export const RATE_STORAGE_KEY = "ax_amp_rate"
export const AUTH_STORAGE_KEY = "ax_amp_auth"
export const ATTENDANCE_STORAGE_KEY = "ax_amp_attendance"



// WEBPACK FOOTER //
// ./src/templates/pages/axoft-maximum-pro/consts/amp.js